import React from 'react';
import { motion } from 'framer-motion';
import { FaLanguage, FaHeadset, FaRocket, FaCogs, FaGift } from 'react-icons/fa';
import './Onboarding.scss';

const onboardingFeatures = [
  {
    id: 1,
    icon: FaRocket,
    title: 'Быстрый старт',
    desc: 'Мы полностью настроим систему, заведем отделы и пропишем иерархию под вашу компанию за пару дней.'
  },
  {
    id: 2,
    icon: FaLanguage,
    title: 'Мультиязычность',
    desc: 'Вся платформа и уведомления доступны на 3 языках: Казахский (KZ), Русский (RU) и Английский (EN).'
  },
  {
    id: 3,
    icon: FaHeadset,
    title: 'Обучение команды',
    desc: 'Мы подготовим понятные инструкции и сами проведем онбординг для ваших сотрудников.'
  },
  {
    id: 4,
    icon: FaCogs,
    title: 'Учет фидбека',
    desc: 'Мы внимательно собираем обратную связь и оперативно наращиваем функционал под ваши нужды.'
  }
];

const Onboarding: React.FC = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { staggerChildren: 0.15 } }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
  };

  return (
    <section id="onboarding" className="onboarding section">
      <div className="container">
        <div className="onboarding__layout">
          <motion.div 
            className="onboarding__text"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="section-badge">Онбординг</span>
            <h2 className="section-title">Мы всё настроим
              <br /><span className="text-gradient">и сделаем удобным</span>
            </h2>
            <p className="section-subtitle">
              Внедрение нового софта часто вызывает сопротивление сотрудников. 
              С beheard вам не нужно об этом переживать — всю тяжелую работу мы берем на себя.
            </p>
            <div className="guarantee-badge">
              <span className="icon">
                {/* @ts-ignore */}
                <FaGift />
              </span>
              <span>Полная настройка с нашей помощью включена в пилотный период</span>
            </div>
          </motion.div>

          <motion.div 
            className="onboarding__grid"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {onboardingFeatures.map((feature) => (
              <motion.div key={feature.id} className="ob-card" variants={itemVariants}>
                <div className="ob-card__icon">
                  {/* @ts-ignore */}
                  <feature.icon />
                </div>
                <div className="ob-card__content">
                  <h4>{feature.title}</h4>
                  <p>{feature.desc}</p>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Onboarding;
